/**
  Creates bar below header for campaign views. Contains an avatar image and discount message.
  Content is set through 'snippets/campaign-widget.liquid'

 --- Uses custom element <campaign-hello-bar>
*/
export class CampaignHelloBar {
  constructor() {
    this.section = document.querySelector("campaign-hello-bar");
    this.closeIcon = false;
    this.active = false;
  }

  _handleClose = () => {
    this.section.style.display = "none";
  };

  _reset = () => {
    this.section = document.querySelector("campaign-hello-bar");
    if (this.section != null) {
      this.closeIcon = this.section.querySelector("campaign-hello-bar-close");
      this.closeIcon.addEventListener("click", this._handleClose);
      this.active = false;
    }
  };
  ß;
  _setReload = () => {
    window.addEventListener("recharge:reload", () => {
      this.section = document.querySelector("campaign-hello-bar");

      if (this.active) {
        this.closeIcon = this.section.querySelector("campaign-hello-bar-close");
        this.closeIcon.addEventListener("click", this._handleClose);
      }
    });
  };

  _init = () => {
    if (this.section != null) {
      this.active = true;
      this.closeIcon = this.section.querySelector("campaign-hello-bar-close");
      this.closeIcon.addEventListener("click", this._handleClose);
      this._setReload();
    }
  };
}
